import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login/login.service';
import { UserProfileService } from 'src/app/services/user-profile/user-profile.service';

interface User {
  name: string;
  surname: string;
  phone: string;
  email: string;
}
@Component({
  selector: 'app-user-update',
  templateUrl: './user-update.page.html',
  styleUrls: ['./user-update.page.scss'],
})
export class UserUpdatePage implements OnInit {
  userID;
  profile;

  updateForm: FormGroup;
  passwordsMatch = false;
  passwordType = 'password';
  passwordIcon = 'eye';
  btnClicked = false;

  constructor(
    private router: Router,
    private menu: MenuController,
    private formBuilder: FormBuilder,
    private auth: AngularFireAuth,
    private profileService: UserProfileService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.auth.authState.subscribe((user) => {
      if (user) {
        this.userID = user.uid;
        this.profileService
          .getProfile(this.userID)
          .pipe(take(1))
          .subscribe((res) => {
            this.profile = res.data() as User;
            const { name, surname, phone, email } = this.profile;
            this.updateForm = this.formBuilder.group({
              name: [
                name,
                [Validators.required, Validators.pattern('^[a-zA-Z]+$')],
              ],
              surname: [
                surname,
                [Validators.required, Validators.pattern('^[a-zA-Z]+$')],
              ],
              phone: [
                phone,
                [Validators.required, Validators.pattern('^0[0-9]{9}$')],
              ],
              email: [
                email,
                [
                  Validators.required,
                  Validators.pattern(
                    '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
                  ),
                ],
              ],
              // password: ['', [Validators.required, Validators.minLength(6)]],
              // passwordConfirmation: [
              //   '',
              //   [Validators.required, Validators.minLength(6)],
              // ],
            });
          });
      } else {
        this.router.navigate(['/home/login']);
      }
    });

    // this.updateForm = this.formBuilder.group({
    //   name: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+$')]],
    //   surname: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+$')]],
    //   phone: ['', [Validators.required, Validators.pattern('^0[0-9]{9}$')]],
    //   email: [
    //     '',
    //     [
    //       Validators.required,
    //       Validators.pattern(
    //         '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
    //       ),
    //     ],
    //   ],
    //   password: ['', [Validators.required, Validators.minLength(6)]],
    //   passwordConfirmation: [
    //     '',
    //     [Validators.required, Validators.minLength(6)],
    //   ],
    // });
  }

  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }

  passwordChange(e) {
    const value = e.target.value;
    const { password, passwordConfirmation } = this.updateForm.value;
    if (value === password && value === passwordConfirmation) {
      this.passwordsMatch = true;
    } else {
      this.passwordsMatch = false;
    }
  }

  update() {
    this.btnClicked = true;
    const { name, surname, phone } = this.updateForm.value;
    const updatedProfile = {
      ...this.profile,
      name,
      surname,
      phone,
    };

    this.profileService
      .updateProfile(this.userID, updatedProfile)
      .then(() => {
        this.btnClicked = false;
        alert('Profile Updated');
      })
      .catch((err) => {
        console.log(err);
        alert('Unable to update profile');
      });
  }

  openUserMenu(menu) {
    this.menu.enable(true, 'dash' + menu);
    this.menu.open('dash' + menu);
  }
  cashier() {
    this.router.navigate(['user-cashier']);
  }

  userProfile() {
    this.router.navigate(['user-home']);
  }
  userUpdate() {
    this.router.navigate(['user-update']);
  }
  userHist() {
    this.router.navigate(['user-history']);
  }
  userOrders() {
    this.router.navigate(['user-orders']);
  }
  logout() {
    this.loginService.logout();
  }
}
